import React, { FC, memo } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';

interface Props {
  title: string;
  onPress: () => void;
}

const Button = styled.TouchableOpacity`
  min-width: 42%;
  max-width: 48%;
  padding-vertical: 11px;
  padding-horizontal: 16px;
  border-width: 1.5px;
  border-color: ${Colors.MAIN_COLOR};
  border-radius: 10px;
  background-color: ${Colors.WHITE};
`;

const ButtonText = styled(Fonts.Bold)`
  color: ${Colors.MAIN_COLOR};
  text-align: center;
  font-size: 16px;
  width: 100%;
`;

const SecondaryButton: FC<Props> = ({ title, onPress }) => {
  return (
    <Button onPress={onPress} accessibilityRole="button">
      <ButtonText>{title}</ButtonText>
    </Button>
  );
};

export default memo(SecondaryButton);
